import { AccessPermissions } from './PermissionContext';
import { PermissionTypes } from './PermissionStrings';
import { CellTrakOperatorClaim } from './ClaimTypes';

export function hasPermission(permissions: AccessPermissions | undefined, accessType: string, accessConcern: string): boolean {
    if (!permissions) {
        return false;
    }

    const validAccessTypes = accessType === PermissionTypes.read ? [PermissionTypes.write, PermissionTypes.read] : [accessType]

    if (permissions) {
        return Object.values(permissions).some(permissionArray =>
            permissionArray?.some(permission =>
                validAccessTypes.includes(permission.accessType) && permission.accessConcern === accessConcern
            )
        );
    }
    return false;
}

export function hasAccountBasedPermission(accountId: string | null | undefined, permissions: AccessPermissions | undefined, accessType: string, accessConcern: string, cellTrakOperatorClaim: CellTrakOperatorClaim | null | undefined): boolean {
    if (!permissions) {
        return false;
    }

    const validAccessTypes = accessType === PermissionTypes.read ? [PermissionTypes.write, PermissionTypes.read] : [accessType]

    if (cellTrakOperatorClaim || !accountId) {
        return hasPermission(permissions, accessType, accessConcern);
    }

    if (permissions) {
        const permissionsForAccount = permissions[accountId];
        return permissionsForAccount?.some(permission => validAccessTypes.includes(permission.accessType) && permission.accessConcern === accessConcern) ?? false;
    }
    return false;
}

export function hasOneOfThesePermissions(permissions: AccessPermissions, requiredPermissions: Record<string, string>) {
    if (!permissions) return false;

    for (let [accessConcern, accessType] of Object.entries(requiredPermissions)) {
        const validAccessTypes = accessType === PermissionTypes.read
            ? [PermissionTypes.write, PermissionTypes.read]
            : [accessType];

        const hasPermission = Object.values(permissions).some(permissionArray => {
            return permissionArray?.some(permission =>
                validAccessTypes.includes(permission.accessType) && permission.accessConcern === accessConcern
            );
        });

        if (hasPermission) {
            return true;
        }
    }

    return false;
}